import { useEffect } from 'react';
import axios from 'axios';
import { getToken } from '../lib/auth';
import { buildDesktopStatus } from '../lib/desktopStatus';

const API_BASE = 'https://teardrophydro.co.uk/garageFarm';
const POLL_MS = 2 * 60_000;
// Days of orders to look through for ones still to pack
const ORDER_DAYS = 14;

const ipcRenderer = window.process?.type === 'renderer' ? window.require('electron').ipcRenderer : null;

// Keeps the farm-status GNOME top-bar extension up to date: every couple of
// minutes, sends main.js a summary of orders to pack and Farm Commander
// health (see lib/desktopStatus.js). Renders nothing, and does nothing
// outside Electron.
export default function DesktopStatusReporter() {
  useEffect(() => {
    if (!ipcRenderer) return undefined;
    let cancelled = false;

    const report = async () => {
      const token = getToken();
      let status;
      if (!token) {
        status = buildDesktopStatus({ signedIn: false });
      } else {
        const headers = { Authorization: `Bearer ${token}` };
        const [orders, commander] = await Promise.allSettled([
          axios.get(`${API_BASE}/orders?days=${ORDER_DAYS}`, { headers }),
          axios.get(`${API_BASE}/farm-commander/status`, { headers }),
        ]);
        const failed = (name, r) => (r.status === 'rejected' ? [`${name}: ${r.reason?.message || 'Request failed'}`] : []);
        status = buildDesktopStatus({
          signedIn: true,
          orders: orders.status === 'fulfilled' ? orders.value.data : null,
          commander: commander.status === 'fulfilled' ? commander.value.data : null,
          errors: [...failed('orders', orders), ...failed('commander', commander)],
        });
      }
      if (!cancelled) ipcRenderer.invoke('desktop-status-set', status).catch(() => {});
    };

    report();
    const t = setInterval(report, POLL_MS);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  return null;
}
